import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomerServiceIcon from '../icons/customer-service.svg';

const PlaceholderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',
  height: '100%',
}));

const PlaceholderIcon = styled('img')(({ theme }) => ({
  width: 64,
  height: 64,
  marginBottom: theme.spacing(2),
  opacity: 0.6,
}));

const CustomerSupport: React.FC = () => {
  return (
    <Paper sx={{ p: 3, height: '100%' }}>
      <PlaceholderContainer>
        <PlaceholderIcon src={CustomerServiceIcon} alt="Customer Support" />
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 1 }}>
          Customer Support
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Customer support features coming soon
        </Typography>
      </PlaceholderContainer>
    </Paper>
  );
};

export default CustomerSupport; 